import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { Single_SchoolClass } from '@graphql/queries'

const useSchoolClass = (id) => {
  const [schoolClass, setSchoolClass] = useState()
  const { data, error, mutate, isValidating } = useSWR(
    id ? [Single_SchoolClass, id] : null
  )

  useEffect(() => {
    if (data?.schoolClass) setSchoolClass(data.schoolClass)
  }, [data, error])

  return {
    schoolClass,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useSchoolClass }
